<template>
  <section data-test="filter-date-range-section">
    <div class="mt-2">
      <label class="from-label text-xxs text-gray-600" for="date-range-select">วันเริ่มต้น - วันสิ้นสุด</label>
      <Datepicker
        v-model="modelValueComputed"
        :enableTimePicker="false"
        :monthChangeOnScroll="false"
        selectText="ตกลง"
        cancelText="ยกเลิก"
        locale="th"
        :month-year-component="monthYear"
        :format="format"
        :previewFormat="format"
        :maxDate="new Date()"
        preventMinMaxNavigation
        range
        :partialRange="true"
        :yearRange="[1900, new Date().getFullYear()]"
      ></Datepicker>
    </div>
  </section>
</template>

<script setup>
import { computed, reactive, ref, watch, onMounted, onUnmounted, defineAsyncComponent } from "vue";
import { useStore } from "vuex";
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

const props = defineProps({
  modelValue: Array,
});
const emits = defineEmits(["update:modelValue"]);

const store = useStore();
const MonthYear = defineAsyncComponent(() => import('../../custom-datepicker/monthComponent.vue'));

const monthYear = computed(() => MonthYear);
const format = (date) => {
  if(date.length == 2){
    const day = ("0" + date[0].getDate()).slice(-2);
    const month = ("0" + (date[0].getMonth() + 1)).slice(-2);
    const year = date[0].getFullYear() + 543;
    const day1 = ("0" + date[1].getDate()).slice(-2);
    const month1 = ("0" + (date[1].getMonth() + 1)).slice(-2);
    const year1 = date[1].getFullYear() + 543;
    let result = []
    result[0] = `${day}/${month}/${year}`
    result[1] = `${day1}/${month1}/${year1}`
    return result.join(' - ')
  }
}
const modelValueComputed = computed({
  get() {
    return props.modelValue;
  },
  set(evt) {
    emits("update:modelValue", evt);
  },
});

</script>
